// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { Calendar } from 'react-calendar'
import 'react-calendar/dist/Calendar.css'
import Switch from 'react-switch'
import {
  AvailabilityTypeSettings,
  Dropdown,
  PopUp,
  getDefaultVisitTypeGroup,
  shouldShowVisitTypeGroupPicker,
} from 'ui_kit_qmd'
import moment from 'moment-timezone'
import { useSelector } from 'react-redux'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import classNames from 'classnames'
import closeIcon from '../../../images/common/close.png'
import './AvailabilityPopUp.scss'
import { PrimaryButton } from '../../../components/ui_kit_quickMD/primary-button/primarybutton'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import calendarIcon from '../../../images/common/calendar.png'
import clockIcon from '../../../images/common/clock.png'
import { getTimeOptionsList } from '../../../utils/commonCalendar'
import {
  generateStatesAbbrArrayFromStateFullNamesArray,
  getDaysOfWeekFromAbbreviationArr,
  getDefaultTimeZoneAbbreviation,
  getOnlyFutureAvailableTimes,
  getTimeZones,
  statesOptions,
  toTimeZone,
} from '../../../utils/common'
import LicensedStatesTool from '../components/licensed-states-tool/LicensedStatesTool'
import RecurrenceSettings from './recurrence-settings/RecurrenceSettings'
import { getPopupBodyMaxHeight, transformToUTCValidFormat } from './helper'
import {
  DATE_TIME_ISO_FORMAT,
  DEFAULT_DATE_FORMAT_WITHOUT_TIME,
  EXTEND_TIME_FORMAT_SMALL,
  MONTH_DAY_DATE_FORMAT,
} from '../../../utils/dateUtils'
import { useProviderLocations } from '../../../api/hooks/useProviderLocations'
import LocationSelector from './LocationSelector'

const dateChangeDropdownIconStyle = {
  width: 24,
  height: 24,
  right: 18,
  top: 18,
  transform: 'none',
}

const availabilityPopUpTimeDropdownContainerStyle = {
  width: 388,
  marginTop: 8,
}

const endDateDropDownCustomIconStyle = {
  width: 24,
  height: 24,
  right: 18,
  top: 18,
  transform: 'none',
}

const availabilityPopUpSaveBtnContainerStyle = {
  width: 422,
  height: 60,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginTop: 24,
}

const popupBodyStyle = {
  maxHeight: getPopupBodyMaxHeight(),
}

const AvailabilityPopUp = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    viewType,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    closePopUpCallback,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    startDate,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    endDate,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickedStartDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    clickedEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setClickedStartDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setClickedEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    occurrenceId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isRecursive,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditMode,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    repeatDays = [],
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    recurrenceEndDateTime,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    scheduleId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    scheduleOrder,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setStartDateHandler,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isShowSelectRecursionChangeModePopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsSelectModePopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    occurrenceOrder,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isRecurrenceOn,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    toggleIsRecurrenceOn,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editScheduleHandler,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    addScheduleHandler,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setReducerError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsSuccessfullyScheduleEdit,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    scheduleInfoFrom,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    scheduleInfoTo,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    addToScheduleSuccess,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    editScheduleSuccess,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    calendarTimeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    providerAvailableStates,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isOverridden = false,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isAppliedForAllLicensedStates = true,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    overriddenStatesCodes = [],
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsShowSelectRecursionChangeModePopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    availableStatesCodesArray,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setAvailableStatesCodesArray,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    daysOfWeekRef,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypeGroups,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    visitTypeGroupId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setShowEditPopUpView,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    providerId,
  }) => {
    const timezones = getTimeZones(allTimezones)
    const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'quickMd' })
    const timeZone = useRef(
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      parseTimezone(calendarTimeZone === 'UTC' ? getDefaultTimeZoneAbbreviation() : calendarTimeZone).label,
    )
    const [isFirstRender, setIsFirstRender] = useState(true)
    const [prevSelectedDays, setPrevSelectedDays] = useState(repeatDays)
    const [isStartTimeChanged, setIsStartTimeChanged] = useState(false)
    const [isFirstRepeatEndDateValueChanged, setIsFirstRepeatEndDateValueChanged] = useState(true)
    const [height, setHeight] = useState(768)
    const [repeatsSelectError, setRepeatsSelectError] = useState('')
    const [availableStatesDropdownError, setAvailableStatesDropdownError] = useState('')
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const recurringBaseTimeZone = useSelector((state) => state.calendarPageReducer.recurringBaseTimeZone)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const scheduleInfoTreatmentCenter = useSelector((state) => state.calendarPageReducer.scheduleInfoTreatmentCenter)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const calendarSchedule = useSelector((state) => state.calendarPageReducer.schedule)
    const [isTimeAdjustedAccordinglyNotFullTimeOptionsList, setIsTimeAdjustedAccordinglyNotFullTimeOptionsList] =
      useState(false)
    const [isRecurrenceEndDateChanged, setIsRecurrenceEndDateChanged] = useState(false)
    const [repeatEndDate, setRepeatEndDate] = useState(recurrenceEndDateTime || '')
    const [isEditLicensedStatesModeOn, setIsEditLicensedStatesModeOn] = useState(
      isOverridden && !isAppliedForAllLicensedStates,
    )

    const isSetAsNeverEnds = recurrenceEndDateTime?.displayDate === 'Invalid date' || !recurrenceEndDateTime
    const [selectedOption, setSelectedOption] = useState([
      { value: 'Never', isChecked: !!isSetAsNeverEnds },
      { value: 'On', isChecked: !isSetAsNeverEnds },
    ])
    const [visitTypeGroup, setVisitTypeGroup] = useState(
      visitTypeGroupId ?
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        visitTypeGroups.find((item) => item.VisitTypeGroupId === visitTypeGroupId)
      : (getDefaultVisitTypeGroup(visitTypeGroups) ?? visitTypeGroups[0]),
    )
    const showVisitTypePicker = shouldShowVisitTypeGroupPicker(visitTypeGroups)
    const { providerLocations, isLoading: locationsLoading } = useProviderLocations(providerId)
    // In-person availability is driven by the selected visit-type group, identified by
    // its "IP" abbreviation (temporary signal until the BE adds an explicit flag to the
    // group contract). Selecting that group surfaces the location dropdown.
    const isInPerson = (visitTypeGroup?.Abbreviation ?? '').toLowerCase() === 'ip'
    const [selectedLocation, setSelectedLocation] = useState(null)
    const [locationSaveAttempted, setLocationSaveAttempted] = useState(false)

    // Restores the previously saved treatment center when opening in edit mode.
    // Runs whenever providerLocations loads or scheduleInfo updates so the selection
    // stays in sync even if the API response arrives after the popup opens.
    useEffect(() => {
      if (!isEditMode || locationsLoading) return
      // Primary: TreatmentCenter from schedule-by-ID fetch (populated by GET_SCHEDULE_BY_ID_SUCCESS)
      let savedCenter = scheduleInfoTreatmentCenter
      // Fallback: look up the occurrence directly in the already-loaded calendar data.
      // Handles non-recurring occurrences that have no ScheduleId and therefore never
      // trigger GET_SCHEDULE_BY_ID_SUCCESS.
      if (!savedCenter && occurrenceId && providerId) {
        const occurrences = calendarSchedule?.[providerId] ?? []
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const occurrence = occurrences.find((o) => o.OccurrenceId === occurrenceId)
        savedCenter = occurrence?.TreatmentCenter ?? null
      }
      if (!savedCenter) return
      // Prefer the version from providerLocations (has current name/address data);
      // fall back to the raw saved center if the location has since been deactivated.
      const matchedLocation = providerLocations.find((loc) => loc.TreatmentCenterId === savedCenter.TreatmentCenterId)
      setSelectedLocation(matchedLocation ?? savedCenter)
    }, [
      isEditMode,
      locationsLoading,
      scheduleInfoTreatmentCenter,
      providerLocations,
      occurrenceId,
      calendarSchedule,
      providerId,
    ])
    // @ts-expect-error TS2532 -- MIGRATION: not approved, fix when encountered
    const isOnSelected = selectedOption[1].isChecked

    const isAllAvailableStatesIsSelected = availableStatesCodesArray.length === providerAvailableStates.length

    const onSetVisitTypeGroup = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const group = visitTypeGroups.find((item) => item.Name === value)
        const groupIsInPerson = (group?.Abbreviation ?? '').toLowerCase() === 'ip'
        setVisitTypeGroup(group)
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        setShowEditPopUpView?.((prev) => ({ ...prev, visitTypeGroupId: group.VisitTypeGroupId }))
        if (!groupIsInPerson) {
          setSelectedLocation(null)
          setLocationSaveAttempted(false)
        }
      },
      [visitTypeGroups],
    )
    const generateAvailableStatesOptionsForDropdown = ({
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      entireArrayOfAvailableStates,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      overriddenArray,
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      isArrayWasOverridden,
    }) => {
      if (!isArrayWasOverridden) {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        return entireArrayOfAvailableStates?.map((elem) => ({
          value: statesOptions?.find((state) => state.includes(elem)) || '',
          isActive: true,
        }))
      }
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      return entireArrayOfAvailableStates?.map((elem) => ({
        value: statesOptions?.find((state) => state.includes(elem)) || '',
        isActive: overriddenArray?.includes(elem),
      }))
    }

    const [availableStates, setAvailableStates] = useState(
      generateAvailableStatesOptionsForDropdown({
        entireArrayOfAvailableStates: providerAvailableStates,
        overriddenArray: overriddenStatesCodes,
        isArrayWasOverridden: isOverridden,
      }),
    )
    useEffect(() => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setAvailableStatesCodesArray(availableStates?.filter((obj) => obj.isActive).map((obj) => obj.value))
    }, [availableStates, setAvailableStatesCodesArray])

    const statesCodesField = useMemo(
      () => ({
        StateCodes:
          isInPerson && selectedLocation ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            selectedLocation.StateCode ?
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [selectedLocation.StateCode]
            : []
          : viewType === 'availability' && !isAllAvailableStatesIsSelected ?
            generateStatesAbbrArrayFromStateFullNamesArray(availableStatesCodesArray)
          : [],
      }),
      [availableStatesCodesArray, isAllAvailableStatesIsSelected, isInPerson, selectedLocation, viewType],
    )
    const fromToTimeFields = useMemo(
      () => ({
        FromDateTime: transformToUTCValidFormat(clickedStartDateTime.dateTime),
        ToDateTime: transformToUTCValidFormat(clickedEndDateTime.dateTime),
      }),
      [clickedEndDateTime.dateTime, clickedStartDateTime.dateTime],
    )

    const currentHeight = useMemo(
      () => window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
      [],
    )

    useEffect(() => {
      setHeight(currentHeight)
    }, [])

    useEffect(() => {
      const isRecurrenceEndDateNotChanged = recurrenceEndDateTime?.dateTime === repeatEndDate?.dateTime

      if (isRecurrenceEndDateNotChanged) {
        setIsRecurrenceEndDateChanged(false)
      } else {
        setIsRecurrenceEndDateChanged(true)
      }
    }, [repeatEndDate])

    useEffect(() => {
      if (editScheduleSuccess) {
        closePopUpCallback(false)
        setIsSuccessfullyScheduleEdit(false)
      }
    }, [editScheduleSuccess])

    useLayoutEffect(() => {
      if (viewType === 'PNB') {
        if (!isEditMode) {
          const date = moment.utc(startDate.dateTime).add(1, 'hours').toString()
          const endDateTimeAccordinglyTimeZone = toTimeZone(date, calendarTimeZone)
          setClickedEndDateTime({
            displayDate: endDateTimeAccordinglyTimeZone.format(MONTH_DAY_DATE_FORMAT),
            displayTime: endDateTimeAccordinglyTimeZone.format(EXTEND_TIME_FORMAT_SMALL),
            dateTime: endDateTimeAccordinglyTimeZone.format(DATE_TIME_ISO_FORMAT),
          })
        }
      }

      setIsFirstRender(false)
    }, [])
    useLayoutEffect(() => {
      if (isEditMode && isRecursive) {
        toggleIsRecurrenceOn(true)
      }
    }, [])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const changeDateTime = (value, type) => {
      switch (type) {
        case 'startTime': {
          const date = moment.utc(startDate.dateTime)
          const correctTimeZoneRow = toTimeZone(date, calendarTimeZone).format().toString()
          const formattedTime = moment(value, 'h:mma').format('HH:mm:00.000')
          const modifiedString = correctTimeZoneRow.slice(0, 11) + formattedTime + correctTimeZoneRow.slice(19)

          const newClickedStartDateTime = {
            displayDate: startDate.displayDate,
            displayTime: value,
            dateTime: modifiedString,
          }
          setClickedStartDateTime(newClickedStartDateTime)
          if (setStartDateHandler) {
            setStartDateHandler(isRecursive, isRecurrenceOn, newClickedStartDateTime, 'startTime')
          }
          setIsStartTimeChanged(true)
          break
        }
        case 'endTime': {
          const date = moment.utc(endDate.dateTime)
          const correctTimeZoneRow = toTimeZone(date, calendarTimeZone).format().toString()
          const formattedTime = moment(value, 'h:mma').format('HH:mm:00.000')
          const modifiedString = correctTimeZoneRow.slice(0, 11) + formattedTime + correctTimeZoneRow.slice(19)

          const newClickedEndDateTime = {
            displayDate: endDate.displayDate,
            displayTime: value,
            dateTime: modifiedString,
          }
          setClickedEndDateTime(newClickedEndDateTime)
          if (setStartDateHandler) {
            setStartDateHandler(isRecursive, isRecurrenceOn, newClickedEndDateTime, 'endTime')
          }
          break
        }
        default:
          break
      }
    }

    useEffect(() => {
      const date = moment.utc(startDate.dateTime).add(4, 'hours').toString()
      const datePNB = moment.utc(startDate.dateTime).add(1, 'hours').toString()
      const endDateTimeAccordinglyTimeZone = toTimeZone(date, calendarTimeZone)
      const endDateTimeAccordinglyTimeZonePNB = toTimeZone(datePNB, calendarTimeZone)
      if (isTimeAdjustedAccordinglyNotFullTimeOptionsList) {
        setIsTimeAdjustedAccordinglyNotFullTimeOptionsList(false)
        return
      }
      if (isStartTimeChanged) {
        setClickedEndDateTime({
          displayDate: endDateTimeAccordinglyTimeZone.format(MONTH_DAY_DATE_FORMAT),
          displayTime: endDateTimeAccordinglyTimeZone.format(EXTEND_TIME_FORMAT_SMALL),
          dateTime: endDateTimeAccordinglyTimeZone.format(DATE_TIME_ISO_FORMAT),
        })
        setIsStartTimeChanged(false)
      } else if (!isFirstRender) {
        setClickedEndDateTime({
          displayDate: endDateTimeAccordinglyTimeZone.format(MONTH_DAY_DATE_FORMAT),
          displayTime: endDateTimeAccordinglyTimeZone.format(EXTEND_TIME_FORMAT_SMALL),
          dateTime: endDateTimeAccordinglyTimeZone.format(DATE_TIME_ISO_FORMAT),
        })
      }
      if (viewType === 'PNB') {
        if (isStartTimeChanged) {
          setClickedEndDateTime({
            displayDate: endDateTimeAccordinglyTimeZonePNB.format(MONTH_DAY_DATE_FORMAT),
            displayTime: endDateTimeAccordinglyTimeZonePNB.format(EXTEND_TIME_FORMAT_SMALL),
            dateTime: endDateTimeAccordinglyTimeZonePNB.format(DATE_TIME_ISO_FORMAT),
          })
          setIsStartTimeChanged(false)
        } else if (!isFirstRender) {
          setClickedEndDateTime({
            displayDate: endDateTimeAccordinglyTimeZonePNB.format(MONTH_DAY_DATE_FORMAT),
            displayTime: endDateTimeAccordinglyTimeZonePNB.format(EXTEND_TIME_FORMAT_SMALL),
            dateTime: endDateTimeAccordinglyTimeZonePNB.format(DATE_TIME_ISO_FORMAT),
          })
        }
      }
    }, [startDate])

    const newDateTimeInUTC = moment.tz(calendarTimeZone)
    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    const timesArrayForSelectedDay = getTimeOptionsList()

    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
    const timesArrayForToday = getOnlyFutureAvailableTimes(getTimeOptionsList(), newDateTimeInUTC, calendarTimeZone)

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const generateTimeOptionsByDate = (value) =>
      !moment(value ?? startDate.displayDate).isAfter(new Date()) ? timesArrayForToday : timesArrayForSelectedDay

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const changeDate = (value, type) => {
      const newDisplayDate = moment(new Date(value)).format(MONTH_DAY_DATE_FORMAT)
      const isFullTimeList = generateTimeOptionsByDate(value).length === 96

      switch (type) {
        case 'startDate': {
          const displayTime = isFullTimeList ? startDate.displayTime : generateTimeOptionsByDate(value)[0]
          const correctTime = moment(displayTime, 'h:mm:ss A').format('HH:mm:ss')

          const dataForRenderStart = moment(`${newDisplayDate} ${correctTime.toString()}`)
            .parseZone()
            .tz(calendarTimeZone, true)
            .toISOString(true)
          const newClickedStartDateTime = {
            displayDate: newDisplayDate,
            displayTime,
            dateTime: dataForRenderStart,
          }

          if (!isFullTimeList) {
            const correctTimeStart = moment(generateTimeOptionsByDate(value)[0], 'h:mm:ss A').format('HH:mm:ss')
            const dateForCorrectEndDate = moment(`${newDisplayDate} ${correctTimeStart.toString()}`).format(
              DATE_TIME_ISO_FORMAT,
            )
            const newCorrectEndDate = moment(dateForCorrectEndDate)
              .add(4, 'hours')
              .parseZone()
              .tz(calendarTimeZone, true)
              .toISOString(true)
            setClickedEndDateTime({
              displayDate: moment(newCorrectEndDate).format(MONTH_DAY_DATE_FORMAT),
              displayTime: moment(newCorrectEndDate).format(EXTEND_TIME_FORMAT_SMALL),
              dateTime: newCorrectEndDate,
            })
            setIsTimeAdjustedAccordinglyNotFullTimeOptionsList(true)
          }

          setClickedStartDateTime(newClickedStartDateTime)
          if (setStartDateHandler) {
            setStartDateHandler(isRecursive, isRecurrenceOn, newClickedStartDateTime, 'startTime')
          }
          break
        }
        case 'endDate': {
          const changedDateEnd = new Date(
            `${moment(newDisplayDate).format(DEFAULT_DATE_FORMAT_WITHOUT_TIME)}T${moment(
              endDate.displayTime,
              EXTEND_TIME_FORMAT_SMALL,
            )
              .format('HH:mm:ss')
              .toString()}`,
          )
          const dataForRenderEnd = moment(changedDateEnd).parseZone().tz(calendarTimeZone, true).toISOString(true)

          const newClickedEndDateTime = {
            displayDate: newDisplayDate,
            displayTime: endDate.displayTime,
            dateTime: dataForRenderEnd,
          }
          setClickedEndDateTime(newClickedEndDateTime)
          if (setStartDateHandler) {
            setStartDateHandler(isRecursive, isRecurrenceOn, newClickedEndDateTime, 'endTime')
          }
          break
        }
        case 'repeatEndDate': {
          setRepeatEndDate({
            displayDate: newDisplayDate,
            dateTime: moment(new Date(value))
              .set({
                hour: 0,
                minute: 0,
                second: 0,
              })
              .parseZone()
              .tz(calendarTimeZone, true)
              .toISOString(true),
          })
          break
        }
        default:
          break
      }
    }

    useEffect(() => {
      if (addToScheduleSuccess) {
        closePopUpCallback(false)
      }
    }, [addToScheduleSuccess])

    useEffect(() => {
      if (setStartDateHandler) {
        if (isRecursive && !isRecurrenceOn) {
          setStartDateHandler(isRecursive, isRecurrenceOn, '', 'startTime')
          setStartDateHandler(isRecursive, isRecurrenceOn, '', 'endTime')
        } else {
          setStartDateHandler(isRecursive, isRecurrenceOn, clickedStartDateTime, 'startTime')
          setStartDateHandler(isRecursive, isRecurrenceOn, clickedEndDateTime, 'endTime')
        }
      }
    }, [isRecurrenceOn])

    const defaultEndRecurrenceDay = useMemo(
      () => ({
        displayDate: moment(clickedEndDateTime.dateTime)
          .parseZone()
          .tz(calendarTimeZone, true)
          .add(1, 'day')
          .set({ hour: 0, minute: 0, second: 0 })
          .format(MONTH_DAY_DATE_FORMAT),
        dateTime: moment(clickedEndDateTime.dateTime)
          .parseZone()
          .tz(calendarTimeZone, true)
          .add(1, 'day')
          .set({ hour: 0, minute: 0, second: 0 })
          .format(DATE_TIME_ISO_FORMAT),
      }),
      [calendarTimeZone, clickedEndDateTime.dateTime],
    )

    const onChangeSwitch = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (value) => {
        toggleIsRecurrenceOn(value)
        if (!isRecursive && isFirstRepeatEndDateValueChanged) {
          setRepeatEndDate(defaultEndRecurrenceDay)
        }
      },
      [defaultEndRecurrenceDay, isFirstRepeatEndDateValueChanged, isRecursive, toggleIsRecurrenceOn],
    )

    const onPressSave = useCallback(() => {
      if (isInPerson && !selectedLocation) {
        setLocationSaveAttempted(true)
        return
      }
      const daysOfWeekList = getDaysOfWeekFromAbbreviationArr(daysOfWeekRef?.current?.getActiveDays())
      const isRepeatDaysWasChanged = daysOfWeekRef?.current?.isRepeatDaysWasChanged()
      if (!moment(clickedStartDateTime.dateTime).isAfter(new Date()) && !isEditMode) {
        setReducerError(
          errorCodes.CANT_SAVE_PAST_DATE,
          viewType === 'availability' ? 'availability' : 'prevent new booking',
        )
      } else if (moment(clickedEndDateTime.dateTime).isBefore(moment(clickedStartDateTime.dateTime))) {
        setReducerError(
          errorCodes.END_BEFORE_START,
          viewType === 'availability' ? 'availability' : 'prevent new booking',
        )
      } else if (moment(clickedEndDateTime.dateTime).isSame(moment(clickedStartDateTime.dateTime))) {
        setReducerError(
          errorCodes.END_BEFORE_START,
          viewType === 'availability' ? 'availability' : 'prevent new booking',
        )
      } else if (moment(clickedStartDateTime.dateTime).add(24, 'hours').isBefore(moment(clickedEndDateTime.dateTime))) {
        setReducerError(
          errorCodes.MORE_THAN_24_HOURS_EVENT,
          viewType === 'availability' ? 'availability' : 'prevent new booking',
        )
      } else if (isRecurrenceOn && !daysOfWeekList.length) {
        setReducerError(errorCodes.FILL_ALL_FIELDS)
        setRepeatsSelectError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, '', 'Repeats on'))
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      } else if (!isInPerson && !availableStates.some((state) => state.isActive) && providerAvailableStates.length) {
        setReducerError(errorCodes.FILL_ALL_FIELDS)
        setAvailableStatesDropdownError(
          getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, '', 'Applicable state(s)'),
        )
      } else if (
        isRecurrenceOn &&
        moment(repeatEndDate.displayDate).isBefore(moment(clickedEndDateTime.displayDate)) &&
        !isEditMode
      ) {
        setReducerError(errorCodes.REPEAT_TIME_AFTER_END)
      } else if (isEditMode) {
        if ((isRecurrenceEndDateChanged || isRepeatDaysWasChanged) && isRecurrenceOn && isRecursive) {
          if (occurrenceOrder === 0) {
            const requestEditFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Schedules: {
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                    RecurringSettings: {
                      EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
              },
            }
            editScheduleHandler(
              requestEditFirstOccurrenceInScheduleBody,
              viewType === 'availability' ? 'availability' : 'unavailability',
            )
          } else {
            const requestEditNonFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Schedules: {
                Create: [
                  {
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                    RecurringSettings: {
                      EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    FromDateTime: scheduleInfoFrom,
                    ToDateTime: scheduleInfoTo,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    RecurringSettings: {
                      EndDateTime: moment(clickedStartDateTime.dateTime)
                        .subtract(1, 'days')
                        .utc()
                        .format('YYYY-MM-DDT00:mm:ss.SSSZ'),
                      WeekDays: repeatDays,
                    },
                  },
                ],
              },
            }
            editScheduleHandler(requestEditNonFirstOccurrenceInScheduleBody)
          }
          return
        }
        if (isShowSelectRecursionChangeModePopUp) {
          setIsSelectModePopUp(true)
          return
        }
        const calendarTitleEle = document.getElementById('calendar-title')
        calendarTitleEle?.setAttribute('data-is-ready-to-click', 'false')
        if (isRecurrenceOn) {
          if (!isRecursive) {
            const correctEditScheduleBody = {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Occurrences: {
                Delete: [occurrenceId],
              },
              Schedules: {
                Create: [
                  {
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                    RecurringSettings:
                      isRecurrenceOn ?
                        {
                          EndDateTime: isOnSelected ? transformToUTCValidFormat(repeatEndDate.dateTime) : null,
                          WeekDays: daysOfWeekList,
                        }
                      : null,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                  },
                ],
              },
            }
            editScheduleHandler(correctEditScheduleBody)
          } else {
            editScheduleHandler({
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Schedules: {
                Create: [
                  {
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                    RecurringSettings: {
                      EndDateTime: isOnSelected ? repeatEndDate.dateTime : null,
                      WeekDays: daysOfWeekList,
                    },
                  },
                ],
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    FromDateTime: scheduleInfoFrom,
                    ToDateTime: scheduleInfoTo,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    RecurringSettings: {
                      EndDateTime: moment(clickedEndDateTime.dateTime)
                        .subtract(1, 'days')
                        .utc()
                        .format(DATE_TIME_ISO_FORMAT),
                      WeekDays: repeatDays,
                    },
                  },
                ],
              },
            })
          }
        } else if (isRecursive) {
          if (scheduleOrder === 0) {
            const requestEditFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Schedules: {
                Delete: [scheduleId],
              },
              Occurrences: {
                Create: [
                  {
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                  },
                ],
              },
            }
            editScheduleHandler(requestEditFirstOccurrenceInScheduleBody)
          } else {
            const requestEditNonFirstOccurrenceInScheduleBody = {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Schedules: {
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    FromDateTime: scheduleInfoFrom,
                    ToDateTime: scheduleInfoTo,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    RecurringSettings: {
                      WeekDays: repeatDays,
                      EndDateTime: moment
                        .utc(clickedStartDateTime.dateTime)
                        .subtract(1, 'days')
                        .format(DATE_TIME_ISO_FORMAT),
                    },
                  },
                ],
              },
              Occurrences: {
                Create: [
                  {
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    Type: viewType === 'availability' ? 'availability' : 'unavailability',
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                  },
                ],
              },
            }
            editScheduleHandler(requestEditNonFirstOccurrenceInScheduleBody)
          }
        } else {
          editScheduleHandler(
            {
              TimeZone: recurringBaseTimeZone || calendarTimeZone,
              Occurrences: {
                Edit: [
                  {
                    ScheduleId: scheduleId,
                    OccurrenceId: occurrenceId,
                    ...fromToTimeFields,
                    ...statesCodesField,
                    VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                    // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                    ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                  },
                ],
              },
            },
            viewType === 'availability' ? 'availability' : 'unavailability',
          )
        }
      } else {
        const calendarTitleEle = document.getElementById('calendar-title')
        calendarTitleEle?.setAttribute('data-is-ready-to-click', 'false')
        if (isRecurrenceOn) {
          addScheduleHandler({
            TimeZone: calendarTimeZone,
            Schedules: {
              Create: [
                {
                  ...fromToTimeFields,
                  ...statesCodesField,
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                  RecurringSettings:
                    isRecurrenceOn ?
                      {
                        EndDateTime: isOnSelected ? transformToUTCValidFormat(repeatEndDate.dateTime) : null,
                        WeekDays: daysOfWeekList,
                      }
                    : null,
                },
              ],
            },
          })
        } else {
          addScheduleHandler({
            TimeZone: calendarTimeZone,
            Occurrences: {
              Create: [
                {
                  ...fromToTimeFields,
                  ...statesCodesField,
                  VisitTypeGroupId: visitTypeGroup.VisitTypeGroupId,
                  Type: viewType === 'availability' ? 'availability' : 'unavailability',
                  // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
                  ...(isInPerson && selectedLocation && { TreatmentCenterId: selectedLocation.TreatmentCenterId }),
                },
              ],
            },
          })
        }

        closePopUpCallback(true)
      }
    }, [
      daysOfWeekRef,
      clickedStartDateTime.dateTime,
      isEditMode,
      clickedEndDateTime.dateTime,
      clickedEndDateTime.displayDate,
      isRecurrenceOn,
      availableStates,
      providerAvailableStates.length,
      repeatEndDate.displayDate,
      repeatEndDate.dateTime,
      setReducerError,
      viewType,
      isRecurrenceEndDateChanged,
      isRecursive,
      isShowSelectRecursionChangeModePopUp,
      occurrenceOrder,
      recurringBaseTimeZone,
      calendarTimeZone,
      scheduleId,
      fromToTimeFields,
      statesCodesField,
      editScheduleHandler,
      isOnSelected,
      scheduleInfoFrom,
      scheduleInfoTo,
      repeatDays,
      setIsSelectModePopUp,
      occurrenceId,
      scheduleOrder,
      closePopUpCallback,
      addScheduleHandler,
      visitTypeGroup,
      isInPerson,
      selectedLocation,
    ])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetRepeatEndDateValue = (value, type) => {
      setIsFirstRepeatEndDateValueChanged(false)
      changeDate(value, type)
    }

    const startTimeOptions = useMemo(
      () =>
        (
          !moment(startDate.displayDate).isAfter(
            new Date(moment().parseZone().tz(calendarTimeZone, false).format('YYYY-MM-DD HH:mm')),
          )
        ) ?
          timesArrayForToday
        : timesArrayForSelectedDay,
      [calendarTimeZone, startDate.displayDate, timesArrayForSelectedDay, timesArrayForToday],
    )

    const onSetEndDateOption = () => {
      setIsRecurrenceEndDateChanged(true)
    }

    return (
      <PopUp
        className={classNames('calendar-availability-pop-up-container')}
        content={
          <>
            <div className='calendar-availability-pop-up-header'>
              <img
                role='presentation'
                alt='Close'
                src={closeIcon}
                className='availability-close-img'
                onClick={() => {
                  closePopUpCallback(false)
                  toggleIsRecurrenceOn(false)
                }}
              />
              {viewType === 'availability' && (
                <span className='availability-title'>{isEditMode ? 'Edit availability' : 'New availability'}</span>
              )}
              {viewType === 'PNB' && (
                <span className='availability-title'>
                  {isEditMode ? 'Edit Prevent new bookings' : 'Prevent new bookings'}
                </span>
              )}
              <span className='calendar-availability-pop-up-timezone-info-block'>
                Your current timezone is <b className='bold'>{timeZone.current}.</b>
              </span>
            </div>
            <div
              className={classNames(
                'calendar-availability-pop-up-body',
                'calendar-availability-pop-up-body--scrollable',
              )}
              style={popupBodyStyle}>
              <div className='availability-datetimepicker-container'>
                <div
                  className={classNames('availability-datetimepicker-box', {
                    'availability-datetimepicker-box--with-scroll': isRecurrenceOn,
                  })}>
                  <Dropdown
                    isDisabled={isRecursive ? isEditMode : null}
                    isDateCase
                    isCalendarOptions
                    value={moment(startDate.displayDate).format('dddd MMM DD YYYY')}
                    calendarValue={startDate.displayDate}
                    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                    setCalendarValue={(value) => changeDate(value, 'startDate')}
                    dropId='Start date*'
                    label='Start date*'
                    customIcon={calendarIcon}
                    isShowStar
                    customIconStyles={dateChangeDropdownIconStyle}
                    minCalendarDate={
                      timesArrayForToday.length === 0 ?
                        new Date(
                          moment().parseZone().tz(calendarTimeZone, false).add(1, 'day').format('YYYY-MM-DD HH:mm'),
                        )
                      : new Date(moment().parseZone().tz(calendarTimeZone, false).format('YYYY-MM-DD HH:mm'))
                    }
                    Calendar={Calendar}
                  />
                  <Dropdown
                    isDateCase
                    options={startTimeOptions}
                    isWithGeneratedOnTheFlyOptions
                    dropdownContainerStyle={availabilityPopUpTimeDropdownContainerStyle}
                    value={startDate.displayTime.replaceAll(' ', '')}
                    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                    setValue={(value) => changeDateTime(value, 'startTime')}
                    dropId='Start time*'
                    label='Start time*'
                    isShowStar
                    customIcon={clockIcon}
                    customIconStyles={dateChangeDropdownIconStyle}
                  />
                </div>
                <div
                  className={classNames('availability-datetimepicker-box', {
                    'availability-datetimepicker-box--with-scroll': isRecurrenceOn,
                  })}>
                  <Dropdown
                    isDisabled={isRecursive ? isEditMode : null}
                    isDateCase
                    showAbove={!isRecurrenceOn && height < 1080}
                    isCalendarOptions
                    value={moment(endDate.displayDate).format('dddd MMM DD YYYY')}
                    calendarValue={endDate.displayDate}
                    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                    setCalendarValue={(value) => changeDate(value, 'endDate')}
                    dropId='End date*'
                    label='End date*'
                    maxDate={moment(clickedStartDateTime.dateTime)
                      .parseZone()
                      .tz(calendarTimeZone, true)
                      .add(24, 'hours')
                      .format(DATE_TIME_ISO_FORMAT)}
                    isShowStar
                    customIcon={calendarIcon}
                    customIconStyles={endDateDropDownCustomIconStyle}
                    minCalendarDate={
                      new Date(
                        moment(startDate.dateTime).parseZone().tz(calendarTimeZone, true).format('YYYY-MM-DD HH:mm'),
                      )
                    }
                    Calendar={Calendar}
                  />
                  <Dropdown
                    isShowStar
                    isDateCase
                    // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
                    options={getTimeOptionsList()}
                    dropdownContainerStyle={availabilityPopUpTimeDropdownContainerStyle}
                    value={endDate.displayTime.replaceAll(' ', '')}
                    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                    setValue={(value) => changeDateTime(value, 'endTime')}
                    dropId='End time*'
                    label='End time*'
                    customIcon={clockIcon}
                    customIconStyles={endDateDropDownCustomIconStyle}
                  />
                </div>
                {viewType === 'availability' && showVisitTypePicker ?
                  <AvailabilityTypeSettings
                    onSetAvailabilityType={onSetVisitTypeGroup}
                    groups={visitTypeGroups}
                    selectedVisitTypeGroup={visitTypeGroup}
                  />
                : null}
                {viewType === 'availability' && isInPerson ?
                  <LocationSelector
                    locations={providerLocations}
                    selectedLocation={selectedLocation}
                    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                    onSelect={setSelectedLocation}
                    // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                    showError={locationSaveAttempted ? !selectedLocation : null}
                    loading={locationsLoading}
                  />
                : null}
              </div>
              {viewType === 'availability' && !isInPerson && (
                <LicensedStatesTool
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  setIsEditLicensedStatesModeOn={setIsEditLicensedStatesModeOn}
                  isEditLicensedStatesModeOn={isEditLicensedStatesModeOn}
                  availableStates={availableStates}
                  availableStatesCodeArray={availableStatesCodesArray}
                  setAvailableStates={setAvailableStates}
                  availableStatesDropdownError={availableStatesDropdownError}
                  setAvailableStatesDropdownError={setAvailableStatesDropdownError}
                  setIsShowSelectRecursionChangeModePopUp={setIsShowSelectRecursionChangeModePopUp}
                  initialOverriddenStatesCodes={overriddenStatesCodes}
                  isRecursive={isRecursive}
                />
              )}
              {viewType === 'availability' ?
                <div className='availability-recurrence-container'>
                  <span className='availability-recurrence-label'>Custom recurrence</span>
                  <Switch
                    onChange={onChangeSwitch}
                    checked={isRecurrenceOn}
                    offColor='#B0BDCB'
                    onColor='#00A2B2'
                    height={30}
                    width={66}
                    uncheckedIcon={<div className='availability-popUp-recurrence-switcher-off-container'> off </div>}
                    checkedIcon={<div className='availability-popUp-recurrence-switcher-on-container'> on </div>}
                    activeBoxShadow='#ffffff'
                  />
                </div>
              : null}
              {isRecurrenceOn ?
                <RecurrenceSettings
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  setRepeatsSelectError={setRepeatsSelectError}
                  endDate={endDate}
                  endDateDropDownCustomIconStyle={endDateDropDownCustomIconStyle}
                  calendarTimeZone={calendarTimeZone}
                  clickedEndDateTime={clickedEndDateTime}
                  onSetRepeatEndDateValue={onSetRepeatEndDateValue}
                  repeatEndDate={repeatEndDate}
                  repeatsSelectError={repeatsSelectError}
                  daysOfWeekRef={daysOfWeekRef}
                  isOnSelected={isOnSelected}
                  repeatDays={repeatDays}
                  prevSelectedDays={prevSelectedDays}
                  setPrevSelectedDays={setPrevSelectedDays}
                  setSelectedOption={setSelectedOption}
                  onChangeButtonGroup={onSetEndDateOption}
                  selectedOption={selectedOption}
                  height={height}
                />
              : null}
            </div>
            <div className='calendar-availability-pop-up-footer'>
              {/*
               // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered */}
              <PrimaryButton
                id='CalendarPopUpSaveBtn'
                btnText='Save'
                containerStyle={availabilityPopUpSaveBtnContainerStyle}
                onPress={onPressSave}
              />
            </div>
          </>
        }
      />
    )
  },
)

export default AvailabilityPopUp
